export default "__VITE_ASSET__926b4c70__"